// componentes
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

// interfaces y modelos
import { ICampanya } from 'src/app/interfaces/campanya';
import { IPreparaciones } from 'src/app/interfaces/preparaciones';
import { IReparto } from 'src/app/interfaces/reparto';
import { IUicLabel } from 'src/app/interfaces/uicLabel';
import FuncLib from 'src/app/providers/funcionesLib';

// servicios
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { RepartosService } from 'src/app/services/datos/repartos.service';
import { UicService } from 'src/app/services/datos/uic.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { SidebarService } from 'src/app/services/sidebar.service';

// librerias y entorno
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-uic-info',
  templateUrl: './uic-info.component.html',
  styleUrls: ['./uic-info.component.scss']
})
export class UicInfoComponent implements OnInit {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  public enviado: boolean = false;
  public loading: boolean = false;

  public fotoDir: string = environment.fotoDir;
  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  public uicLabel: IUicLabel = {};
  public campanyaInfo: ICampanya = {};

  public listPreparacion: IPreparaciones[] = [];
  public listReparto: IReparto[] = [];
  public listUicsPedido: any[] = [];
  public listUics: any[] = [];
  public listCajas: any[] = [];

  public uicTotales: any = {};

  public formInfo: FormGroup = new FormGroup({});
  uicParam: string | null = null;
  imagenSeleccionada: string | null = null;

  constructor(
    private fb: FormBuilder,
    private notificacionesSrv: NotificacionesService,
    public uicSrv: UicService,
    public clientesSrv: ClientesService,
    private usuarioSrv: UsuarioService,
    private RepartoSrv: RepartosService,
    private activatedRoute: ActivatedRoute,
    private sidebarSrv: SidebarService

  ) { }

  ngOnInit(): void {

    this.sidebarSrv.expandMenu('pedidos'); // Forzar el abrir menú de pedidos

    this.formInfo = this.fb.group({
      uic: ['', Validators.required],
      id_usuario: [this.usuarioSrv.userdata.id]
    });

    // Si pasan el UIC por la URL, lo leemos y lo enviamos
    this.activatedRoute.paramMap.subscribe(params => {
      this.uicParam = params.get('uic');
      if (this.uicParam) {
        this.formInfo.get('uic')?.setValue(this.uicParam.toUpperCase());
        this.enviar();
      }
    });
  }

  enviar() {
    this.enviado = true;

    // Validar UIC

    const uicControl = this.formInfo.get('uic')?.value.toUpperCase();
    this.formInfo.patchValue({ uic: uicControl });
    const uicRegex = /^UIC\d{10}$/;  // 'UIC' seguido de 10 dígitos

    if (!uicRegex.test(uicControl)) {
      this.formInfo.get('uic')?.setErrors({ formatoIncorrecto: true });
      return;
    }

    // info de valUic
    this.loading = true;
    this.uicSrv.valUic(uicControl)
      .subscribe(async resp => {
        this.loading = false;
        console.log('__valUic resp', resp);
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          this.formInfo.get('uic')?.setErrors({ apiError: resp.mensaje });
          this.uicLabel = {}
          return;
        }

        this.uicLabel = resp.data;
        console.log('__uicLabel', this.uicLabel);
      });


    // info de uicInfo
    this.loading = true;
    this.RepartoSrv.getUicInfo(uicControl)
      .subscribe(async resp => {
        this.loading = false;
        console.log('__valUic getUicInfo resp', resp);
        if (resp.error) {
          this.notificacionesSrv.aviso('error', resp.mensaje);
          return;
        }

        this.listPreparacion = resp.data.listPreparacion;
        this.listReparto = resp.data.listReparto;
        this.listUicsPedido = resp.data.listUicsPedido;
        this.listCajas = resp.data.listCajas;

        // Obtener array con todos los UIC sin repetir  
        const uicsUnicosSet = new Set(this.listUicsPedido.map(item => item.uic));
        const uicsUnicosArray = Array.from(uicsUnicosSet).filter(uic => uic && uic.trim() !== ''); // Filtrar elementos vacíos
        this.listUics = uicsUnicosArray.sort();

        this.uicTotales = resp.totales;
        this.campanyaInfo = resp.totales.campanya;

        console.log('__listPreparacion', this.listPreparacion);
        console.log('__listReparto', this.listReparto);
        console.log('__listUicsPedido', this.listUicsPedido);
        console.log('__listCajas', this.listCajas);
        console.log('__listUics', this.listUics);
        console.log('__uicTotales', this.uicTotales);
        console.log('__campanyaInfo', this.campanyaInfo);

      });

  }


  // getters de totales
  get totalCantReserva(): number {
    return this.listPreparacion.reduce((acc, item) => acc + Number(item.cant_reserva || 0), 0);
  }

  get totalCantRecogida(): number {
    return this.listPreparacion.reduce((acc, item) => acc + Number(item.cant_recogida || 0), 0);
  }

  get totalCantPedido(): number {
    return this.listReparto.reduce((acc, item) => acc + Number(item.cant_pedido || 0), 0);
  }

  get totalCantRepartir(): number {
    return this.listReparto.reduce((acc, item) => acc + Number(item.cant_repartir || 0), 0);
  }

  get totalCantRepartida(): number {
    return this.listReparto.reduce((acc, item) => acc + Number(item.cant_repartida || 0), 0);
  }

  get totalCajas(): number {
    return this.listCajas.reduce((acc, item) => acc + Number(item.cajas || 0), 0);
  }


  seleccionarUIC(uicSeleccionado: string) {
    this.formInfo.patchValue({ uic: uicSeleccionado });
    this.enviar();
  }

  //// Aux  ///


  get f() {
    return this.formInfo.controls;
  }



  // Modal imágen
  abrirPopupImagen(url: string) {
    console.log('__abrirPopupImagen()', url);
    if (url.includes('_noFoto')) return
    this.imagenSeleccionada = url;
  }

  cerrarPopupImagen() {
    this.imagenSeleccionada = null;
  }



}
